import { SvgIcon, SvgIconProps } from '@mui/material';

const BlobIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="162" height="142" viewBox="0 0 162 142">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M70.2231 2.15535C92.5383 -3.24001 114.968 7.23173 132.419 21.8308C149.57 36.1795 164.896 56.3645 161.303 78.3522C158 98.5602 133.886 105.288 116.857 117.042C101.474 127.66 88.2499 142.08 69.5352 141.693C44.4364 141.175 13.9209 137.196 3.53455 114.701C-6.84812 92.2139 13.3649 68.9786 26.0655 47.5448C37.3482 28.5036 48.5377 7.3984 70.2231 2.15535Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};

export default BlobIcon;
